module.exports = __webpack_public_path__ + "img/lady.2aba80fe.png";